import { Component } from '@angular/core';

@Component({
  selector: 'app-how-to-publish',
  standalone: true,
  imports: [],
  templateUrl: './how-to-publish.component.html',
  styleUrl: './how-to-publish.component.scss'
})
export class HowToPublishComponent {

}
